import {
  Component,
  input,
  effect,
  ElementRef,
  inject,
  viewChild,
} from '@angular/core';
import { ScriptInjectorService } from '../script-injector.service';

@Component({
  selector: 'hsuc-safe-script',
  imports: [],
  template: `<span #scriptTarget></span>`,
})
export class SafeScriptComponent {
  scriptCode = input<string>();
  scriptTarget = viewChild.required<ElementRef<HTMLDivElement>>('scriptTarget');
  scriptInjector = inject(ScriptInjectorService);
  constructor() {
    effect(() => {
      if (!this.scriptTarget()) {
        return;
      }
      this.scriptTarget().nativeElement.innerHTML = '';
      const fragment = document
        .createRange()
        .createContextualFragment(this.scriptCode() ?? '');
      this.scriptTarget().nativeElement.appendChild(fragment);
    });
  }

}
